import Head from 'next/head'
import DocumentDetail from '../../components/info/documentDetail'
import Breadcrumbs from '../../components/breadcrumbs'
import documentData from '../../constants/documents'

const DocumentTypesPage = () => (
  <>
    <Head>
      <title>Tipos de documentos</title>
      <link rel="icon" href="/favicon.ico" />
    </Head>
    <Breadcrumbs
      crumbs={[
        { text: "Inicio", link: "/" },
        { text: "Información", link: "/info" },
        { text: `Tipos de documentos`, link: "#" },
      ]}
    />
    <div style={{textAlign: 'center' }}>
      <h2>Tipos de documentos</h2>
    </div>
    {Object.keys(documentData).map((docType, idx) => {
      if (typeof documentData[docType].img === "undefined") return
      return (
        <DocumentDetail
          key={docType}
          reverse={idx % 2 ? true : false}
          documentName={documentData[docType].name}
          detail={documentData[docType].detail}
          img={documentData[docType].img} />
      )
    })}
  </>
)
 
export default DocumentTypesPage